import React from 'react';

const SvgLinkedin = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 15 15" {...props}>
    <path
      fill="currentColor"
      d="M14.945 9v5.68h-3.204v-5.3c0-1.33-.462-2.239-1.622-2.239-.886 0-1.412.612-1.644 1.204-.084.212-.106.506-.106.803v5.532H5.165s.043-8.976 0-9.905h3.204v1.403l-.021.033h.021v-.033c.426-.673 1.185-1.636 2.888-1.636 2.108 0 3.688 1.416 3.688 4.458zM1.813 0C.717 0 0 .74 0 1.711c0 .951.696 1.712 1.771 1.712h.02c1.118 0 1.813-.76 1.813-1.712C3.583.74 2.91 0 1.814 0zM.19 14.68h3.203V4.775H.19v9.905z"
    />
  </svg>
);

export default SvgLinkedin;
